/**
 * Padel USA — keep a clicked PDP accordion header under the pointer (owner 2026-10-09).
 *
 * The desktop product-details column is `position: sticky` (block setting sticky_details_desktop).
 * While it fits the viewport it is pinned at the top; opening a long row (Description) makes it
 * taller than the gallery, so it can no longer stick and drops back to its in-flow position, which
 * is already scrolled past: the whole column — and the header just clicked — jumps up by hundreds
 * of pixels (309px on Head Motion PRO 1.5). Closing a row can jump the other way.
 *
 * Fix: on a header click, remember where it sat and, for the length of the open/close animation,
 * scroll the page by any drift so the header stays put and the content grows downward. Stops as
 * soon as the shopper scrolls themselves. No effect when nothing moves (mobile, short columns).
 * Loaded from blocks/_accordion-row.liquid. Dossier: custom-code-padelusa/features/pdp-accordion-content.md
 */
const HOLD_MS = 700;

document.addEventListener(
  'click',
  (event) => {
    const target = /** @type {Element | null} */ (event.target instanceof Element ? event.target : null);
    const summary = target?.closest('.product-details accordion-custom summary');
    if (!summary) return;

    const start = summary.getBoundingClientRect().top;
    const until = performance.now() + HOLD_MS;
    // html { scroll-behavior: smooth } turns every correction into a smooth scroll that the next
    // frame's correction cancels (Chrome ignores behavior: 'instant' here), so the page never moves.
    // Switch it off for the hold, then restore.
    const root = document.documentElement;
    const previousBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    let active = true;
    const stop = () => {
      active = false;
      root.style.scrollBehavior = previousBehavior;
    };
    const userScroll = { once: true, passive: true };
    window.addEventListener('wheel', stop, userScroll);
    window.addEventListener('touchstart', stop, userScroll);
    window.addEventListener('keydown', stop, { once: true });

    const hold = () => {
      if (!active) return;
      const drift = summary.getBoundingClientRect().top - start;
      if (Math.abs(drift) >= 1) window.scrollBy(0, drift);
      if (performance.now() < until) {
        requestAnimationFrame(hold);
      } else {
        stop();
        window.removeEventListener('wheel', stop);
        window.removeEventListener('touchstart', stop);
        window.removeEventListener('keydown', stop);
      }
    };
    requestAnimationFrame(hold);
  },
  { capture: true }
);
